import axios from "axios";
const instance = axios.create({
	timeout: 20000,
	timeoutErrorMessage: "Oops..! Qualcosa è andato storto. Riprova più tardi.",
});

export default instance;
